// Dependencies
import React, { useEffect, useMemo, useState } from "react";

// Modules

// App
import { apiEndpoints } from "../../config";

import { FormControlLabel, Checkbox, Typography } from "@mui/material";

import PostEdit from "../../partials/posts/postEdit";

export default function TrainingEdit() {
  const [editorContent, setEditorContent] = useState(null);
  const [post, setPost] = useState(null);
  const [allowSubmission, setAllowSubmission] = useState(false);

  useEffect(() => {
    if (post !== null && editorContent === null) {
      setEditorContent(post.body);
    }
    if (post !== null) {
      setAllowSubmission(post?.allow_submission ?? false);
    }
  }, [post, editorContent]);

  const extraFields = useMemo(() => {
    if (editorContent) {
      const trainingBlocks = editorContent.blocks.filter(
        (block) => block.type === "trainingSection",
      );
      const entitySelection = trainingBlocks.flatMap((block) =>
        block.data.entities.map((entity) => ({
          id: entity.id,
          bundle: entity.bundle,
        })),
      );
      return {
        field_references: entitySelection,
        allow_submission: allowSubmission,
      };
    }
  }, [editorContent, allowSubmission]);

  return (
    <PostEdit
      entityType={"training"}
      apiEndpoint={apiEndpoints.training}
      screenClassName={"training"}
      categoryTitle={"Training category"}
      categoryName={"field_training_category"}
      targetVid={"training_categories"}
      returnRoute={"/training-creator"}
      backBtnText={"Training Library"}
      previewRoute={"/training/preview"}
      logCustomEventType={"Course"}
      extraFields={extraFields}
      featuredImageEnabled={true}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      setEntityEditorContent={(body) => {
        setEditorContent(body);
      }}
      editorProps={{
        title: true,
        subtitle: true,
        body: true,
        list: true,
        table: true,
        image: true,
        video: true,
        embed: true,
        rule: true,
        buttonGroup: true,
        chart: true,
        map: true,
        trainingSection: true,
      }}
      disableReactions={true}
      disableComments={true}
      setEditorContent={setEditorContent}
      imageBlockEnabled={true}
    >
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            checked={allowSubmission}
            onChange={(event) => {
              setAllowSubmission(event.target.checked);
            }}
          />
        }
        label={
          <Typography owner="admin" variant="body2">
            Require submission
          </Typography>
        }
      />
    </PostEdit>
  );
}
